import { io } from "socket.io-client";

const SERVER_URL = "https://server.f-machine.com";

export const socket = io(SERVER_URL, {
  transports: ["websocket"],
});